<div class="dialog-wrapper">

  <h1 mat-dialog-title class="dialog-title">Koppla maskin {{ data.machine.baseInfo.machineId}} till maskinlag</h1>

  <div class="dialog-header">
    <mat-form-field appearance="outline" class="search-filter">
      <mat-label>Sök</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Skriv för att filtrera" class="search-input">
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>


    @if(configuredTeams.length !== 0) {
    <p>Antal ändringar: {{configuredTeams.length }}</p>
    }

    <mat-checkbox (change)="onChangeShowDeactivatedMachines($event.checked)" class="dialog-header-checkbox">
      <mat-label>Visa inaktiva</mat-label>
    </mat-checkbox>
  </div>

  <mat-dialog-content>
    <div class="machine-info-container">

      <table mat-table [dataSource]="teamsDataSource" class="mat-elevation-z8 machine-table">
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            <mat-checkbox [checked]="teamIsAdded(element)" (change)="onCheckboxChange(element, $event)"
              class="column-checkbox">
            </mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="teamId">
          <th mat-header-cell *matHeaderCellDef>Maskinlags-Id</th>
          <td mat-cell *matCellDef="let element"> {{ element.teamId }} </td>
        </ng-container>

        <ng-container matColumnDef="productionTechnicianAreaText">
          <th mat-header-cell *matHeaderCellDef>Prodteknikerområde</th>
          <td mat-cell *matCellDef="let element"> {{ element.productionTechnicianAreaText }} </td>
        </ng-container>

        <ng-container matColumnDef="baseInfo.name">
          <th mat-header-cell *matHeaderCellDef>Namn</th>
          <td mat-cell *matCellDef="let element">{{ element.baseInfo.name }}</td>
        </ng-container>

        <ng-container matColumnDef="productionInfo.statusInfo.statusText">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let element">{{ element.statusInfo.statusText }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayColumns;"></tr>
      </table>

    </div>

  </mat-dialog-content>

  <div mat-dialog-actions class="dialog-actions">
    <button mat-raised-button (click)="onCancel()">Avbryt</button>

    <button mat-raised-button class="main-action-button" color="primary" (click)="onConfirm()" cdkFocusInitial
      [disabled]="configuredTeams.length === 0">Välj markerade</button>


  </div>
</div>